<template>
    <div>
        <div class="topbar">
            <div class="wrap_w">
                <!--<div class="top-left">-->
                    <!--<router-link :to="'/user/1-1'">{{contents[1066]}}</router-link>-->
                <!--</div>-->
                <!--<div class="top-right">-->
                    <!--<a href="#" @click="showLoginBox" v-if="!account">{{contents[1067]}}</a>-->
                    <!--<template v-if="account">-->
                        <!--<a>{{contents[1068]}}{{account}}</a>-->
                        <!--<span style="line-height: 26px;">{{contents[1069]}}</span>-->
                        <!--<a @click="loginOut" style="cursor: pointer;">{{contents[1070]}}</a>-->
                    <!--</template>-->
                <!--</div>-->
            </div>
        </div>

        <div class="loginBg" v-if="showLogin">
            <div style="height: 100%;width: 100%;background-color: #313131;position: fixed;top: 0;left: 0;opacity: 0.7;z-index: 9;" @click="showLogin = false"></div>
            <div class="loginCenter">
                <div class="loginArea"></div>
                <el-form label-width="0" :model="loginData" :rules="loginRules" ref="loginForm">
                    <h3>{{contents[1071]}}</h3>
                    <el-form-item label="" prop="loginName">
                        <el-input placeholder="请输入账号" v-model.trim="loginData.loginName"
                                  @keyup.enter.native="login('loginForm')">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="" prop="pwd">
                        <el-input type="password" v-model.trim="loginData.pwd" placeholder="请输入密码"
                                  @keyup.enter.native="login('loginForm')">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="" prop="">
                        <el-button style="width: 100%" type="primary" @click="login('loginForm')">{{contents[1072]}}</el-button>
                        <p>
                            <span>{{contents[1073]}}</span>
                            <router-link style="float: right" :to="'/register'" class="el-button--text"><span @click="showLogin = false">{{contents[1074]}}</span>

                            </router-link>
                        </p>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>

</template>

<script>
    import httpRequest from '../service/http_request';
    import {mapState} from 'vuex'

    const icp = require('../lib/icp');
    const Utils = require('../lib/utils');

    export default {
        name: "topbar",
        data () {
            return {
                showLogin: false,
                loginData: {
                    loginName: '',
                    pwd: ''
                },
                // rules
                loginRules: {
                    loginName: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                        {min: 6, max: 15, message: '长度在 6 到 15 个字符之间', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ]
                },
                // account: ''

                contents: ''

            }
        },
        computed: {
            ...mapState({
                account: state => state.account
            }),
        },
        created() {
            if (Utils.getCookie('token') != undefined) {
                // this.account = Utils.getCookie('account');
                this.$store.commit("updateUserInfo", Utils.getCookie('account'));
            }
            this.getContent();
        },
        methods: {
            showLoginBox() {
                this.showLogin = true;
            },

            // 提交登录
            login(formName) {
                var self = this;
                self.$refs[formName].validate((valid) => {
                    if (valid) {
                        httpRequest.request(
                            'post',
                            icp.urls.account_login, {
                                account: self.loginData.loginName,
                                password: self.loginData.pwd
                            }, function (res) {
                                if (res != null) {
                                    Utils.setCookie('account', res.account);
                                    Utils.setCookie('headerimg', res.headerimg);
                                    Utils.setCookie('token', res.token);
                                    self.$store.commit("updateUserInfo", res.account);//更新登录状态
                                    self.$router.push('/loginSuccess');
                                }
                            })
                    } else {
                        self.$message({
                            message: '请填写用户名跟密码',
                            type: 'warning'
                        });
                        return false;
                    }
                });
                this.showLogin = false;
            },
            //退出
            loginOut() {
                this.addLog();
                Utils.delCookie('token');
                Utils.delCookie('account');
                Utils.delCookie('headerimg');
                this.$store.commit("updateUserInfo", '');//更新登录状态
                this.$router.push({
                    path: '/loginOut'
                });
            },

            getContent() {
                var self = this;
                httpRequest.request(
                    'post',
                    icp.urls.page_getContents, {
                        params:{
                            page: 19
                        }
                    }, function (res) {
                        self.contents = res;
                    })
            },
            //页面日志
            addLog() {
                httpRequest.request(
                    'post',
                    icp.urls.page_addLog, {
                        params: {
                            action: '退出',
                            actionUrl: '/loginOut',
                            actionContent: '用户退出'
                        }
                    }, function (res) {

                    })
            }
        }
    }
</script>

<style scoped lang="less">
    .topbar {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #eeeeee;
        background: #F5F5F5;
        color: #ddd;

        .wrap_w {
            width: 1200px;
            margin: 0 auto;
            text-align: left;

            .top-left {
                float: left;

                a {
                    display: inline-block;
                    color: #7c7c7c;
                    margin: 0 10px;
                    font-size: 12px;
                }
                a:hover {
                    color: #2db267;
                }
            }

            .top-right {
                height: 37px;
                text-align: right;
                line-height: 37px;
                float: right;
                color: #ccc;

                a {
                    color: #6c6c6c;
                    font-size: 12px;
                }
                a:hover {
                    color: #2db267;
                }
            }
        }
    }

    .loginBg {
        position: relative;

        .loginCenter {
            position: fixed;
            padding: 20px;
            top: 50%;
            left: 50%;
            width: 260px;
            height: 290px;
            z-index: 99;
            transform: translate(-50%, -50%);
            filter: alpha(opacity=50);
            -moz-opacity: 0.5;
            -khtml-opacity: 0.5;
            border-radius: 15px;
            overflow: hidden;

            .loginArea {
                position: absolute;
                padding: 20px;
                width: 260px;
                height: 290px;
                top: 0;
                left: 0;
                background: #FFF;
                opacity: 0.8;
            }

            .el-form {
                position: absolute;
                padding: 20px;
                width: 260px;
                height: 290px;
                top: 0;
                left: 0;
                background: transparent;

                h3 {
                    margin-bottom: 10px;
                }
            }

            .user {
                position: absolute;
                padding: 20px;
                width: 260px;
                height: 290px;
                top: 0;
                left: 0;
                background: transparent;

                .userLogo {
                    margin-top: 10px;
                    padding-right: 10px;
                    width: 90px;
                    height: 90px;
                    float: left;

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                    }
                }

                p {
                    margin-bottom: 10px;
                }

                a + a {
                    margin-left: 10px;
                }

                h4 {
                    height: 35px;
                    line-height: 35px;
                    font-weight: bold;
                }

                .user-bottom {
                    border-bottom: 1px solid #33b874;
                    padding: 10px 0;
                    text-align: center;

                    a:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/topbar.vue